import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { styled, css } from 'styled-components';
"use strict";
function StickyGridItem({
  stickX,
  ...props
}) {
  const ref = useRef(null);
  return /* @__PURE__ */jsx(StyledStickyGridItem, {
    ref,
    ...props,
    $stickX: stickX
  });
}
const StyledStickyGridItem = styled.div`
  ${({
  $stickX
}) => {
  if ($stickX === true) {
    return css`
        position: sticky;
        left: 0;
        right: 0;
      `;
  }
  if (typeof $stickX === "string") {
    return css`
        position: sticky;
        left: ${$stickX};
      `;
  }
  return void 0;
}}
`;
export { StickyGridItem };
//# sourceMappingURL=StickyGridItem.mjs.map
